import { Provider } from '@angular/core';

import { UserApi } from '@mark/web-contracts';

import { CommonGrpcContractFactory } from './common.service.provider';

export const SurveyBhUserGrpcContractProvider: Provider = {
  provide: UserApi.SurveyBhUserWebGrpcContractClient,
  useFactory: CommonGrpcContractFactory(UserApi.SurveyBhUserWebGrpcContractClient, 'userApi'),
};
